var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTopArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 346,
    height: 354,
    viewBox: "0 0 346 354",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 162.5,
    cy: 164.5,
    rx: 162.5,
    ry: 164.5,
    fill: "#0E2A40"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M150.806 46.6471L286.711 243.634C288.569 246.327 286.584 249.99 283.313 249.904L218.414 248.196C217.072 248.16 215.837 247.454 215.126 246.314L164.056 164.443C162.241 161.533 157.844 162.108 156.838 165.387L132.428 244.952C131.913 246.632 130.361 247.779 128.604 247.779L52.9113 247.779C49.9582 247.779 48.0232 244.688 49.3129 242.032L143.915 47.1717C145.253 44.4156 149.066 44.1253 150.806 46.6471Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopArrow);
export default __webpack_public_path__ + "static/media/top_arrow.b418b6b987183d91a9fc16b2bb7c1510.svg";
export { ForwardRef as ReactComponent };